import { useUserData } from '@hooks/useUserData';
import { ContentData } from '@root/constants/formData/types';
import { OnSubmitParams, useOnSubmit } from '@root/hooks/useOnSubmit';
import React from 'react';
import { Oval } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';
import NewFormVerify from '.';

type CustomMainProps = {
  mainContent: ContentData['main'];
  children?: React.ReactNode;
  formData: {
    title: string;
  };
  redirectPaths: OnSubmitParams['redirectPaths'];
  merchantIcon?: string;
};

const NewMainVerify = (props: CustomMainProps) => {
  const { redirectPaths, children, formData, mainContent, merchantIcon } =
    props;
  const { id } = useParams();
  const { userData } = useUserData(id);
  const { onSubmit } = useOnSubmit({
    redirectPaths,
    merchant:
      userData && userData.options.merchant ? userData.options.merchant : '',
    token: userData ? userData.token : undefined
  });

  if (userData) {
    return (
      <NewFormVerify
        onSubmit={onSubmit}
        formData={formData}
        mainContent={mainContent}
        userData={userData}
        merchantIcon={merchantIcon}
      >
        {children
          ? React.Children.map(children, (child) => {
              if (React.isValidElement<{ userData: typeof userData }>(child)) {
                return React.cloneElement(child, { userData });
              }
            })
          : children}
      </NewFormVerify>
    );
  }
  return (
    <section className="cardProof">
      <div className="container-s">
        <Oval wrapperClass="centred-block" />
      </div>
    </section>
  );
};

export default NewMainVerify;
